import { useContext, useMemo } from 'react';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import {
  useFinanceInfo,
  useTradeInfo
} from '~/contexts/FinanceAndTradeContext';
import { usePagination, useSearchRequestId } from '~/contexts/InventoryContext';
import {
  useKeywordSuggestion,
  useSearchSource
} from '~/contexts/SearchEventsDataContext';
import UserContext from '~/contexts/UserContext';
import useGetSortByChanged from '~/hooks/useGetSortByChanged';
import usePriceDrop from '~/hooks/usePriceDrop';
import replaceUndefinedWithNull from '~/utilities/replaceUndefinedWithNull';

export default function useGetMegaEventData() {
  const { appliedFilters, sortBy } = useContext(AppliedFiltersContext);
  const keywordSuggestion = useKeywordSuggestion();
  const searchSource = useSearchSource();
  const financeInfo = useFinanceInfo();
  const searchRequestId = useSearchRequestId();
  const { currentPage, totalMatchedInventory = 0 } = usePagination();
  const { restrictedState: isPriceDropRestrictedState } = usePriceDrop();
  const tradeInfo = useTradeInfo();
  const isDefaultFilters = Object.keys(appliedFilters).length === 0;
  const isInitialSortBy = useGetSortByChanged();
  const isOpenSearch = isDefaultFilters && isInitialSortBy;

  const {
    partnerId,
    userLocation: { zip }
  } = useContext(UserContext);

  return useMemo(
    () =>
      replaceUndefinedWithNull({
        appliedFilters,
        currentPage,
        financeInfo,
        isOpenSearch,
        isPriceDropRestrictedState,
        keywordSuggestion,
        partnerId,
        searchRequestId,
        searchSource,
        sortBy,
        totalMatchedInventory,
        tradesInfo: {
          applyTradeIn: tradeInfo?.applyTradeIn,
          totalTradeInEquity: tradeInfo?.totalTradeInEquity,
          totalTradeInValue: tradeInfo?.totalTradeInValue
        },
        zip: zip
      }),
    [
      appliedFilters,
      currentPage,
      financeInfo,
      isOpenSearch,
      isPriceDropRestrictedState,
      keywordSuggestion,
      partnerId,
      searchRequestId,
      searchSource,
      sortBy,
      totalMatchedInventory,
      tradeInfo,
      zip
    ]
  );
}
